module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-filter-or-block"
  }, [_c('div', {
    staticClass: "block"
  }, _vm._l((_vm.expression.args), function(arg, argId) {
    return _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('div', {
      staticClass: "orLine"
    }, [_vm._v(_vm._s(_vm.i18n().orLine))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "orRow"
    }, [_c('div', {
      staticClass: "expr"
    }, [_c('TopFilterLogicBlock', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [(_vm.parent) ? _c('button', {
      staticClass: "mdl-button delete-button",
      on: {
        "click": function($event) {
          _vm.deleteArg(argId)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]) : _vm._e(), _vm._v(" "), (_vm.definition.isList) ? _c('button', {
      staticClass: "mdl-button add-button",
      on: {
        "click": _vm.addArg
      }
    }, [_vm._v(" " + _vm._s(_vm.i18n().or) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.definition.isList && argId + 1 == _vm.expression.args.length) ? _c('button', {
      staticClass: "mdl-button add-button",
      on: {
        "click": _vm.addOuterAnd
      }
    }, [_vm._v(" " + _vm._s(_vm.i18n().and) + "\n          ")]) : _vm._e()])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f83fa208"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/query/TopFilterOrBlock.vue
// module id = 474
// module chunks = 0